import { Input, Empty, Tooltip, Pagination, Select } from "antd";
import { BsArrowDownUp } from "react-icons/bs";
import { convertToObjectKeyString, TranslateString } from "Utils/Common";
import { useIntl } from 'react-intl';
import { useState } from "react";
import moment from "moment";
import { LogStatus } from "constants/Constants";

const LogsList = (props: any) => {
    const intl = useIntl();
    const [SearchLogs, setSearchLogs] = useState<any>(props?.searchData || {});
    const [logStatus, setLogStatus] = useState({is_active:''})

    const onSearch = (event: any) => {
        const { target } = event;
        const value = target.value;
        const { name } = target;
        setSearchLogs({ ...SearchLogs, [name]: value });
    };

    const onPressEnter = (event: any) => {
        props.setSearchData({ ...SearchLogs, ...logStatus });
    };

    return (
        <>
            <div className='cu-table-border'>
                <table className="table table-sm table-bordered table-striped text-left m-0">
                    <thead>
                        <tr className="align-middle cu-text-small">
                            <td className="cu-bg-green fw-bold">{TranslateString('name')}</td>
                            <td className="cu-bg-green fw-bold text-center">{TranslateString('customer_id')}</td>
                            <td className="cu-bg-green fw-bold">{TranslateString('customer_name')}</td>
                            <td className="cu-bg-green fw-bold">{TranslateString('loan_name')}</td>
                            <td className="cu-bg-green fw-bold">{TranslateString('status')}</td>
                            <td className="cu-bg-green fw-bold">{TranslateString('reason')}</td>
                            <td className="cu-bg-green fw-bold">{TranslateString('date')}</td>
                            <td className="cu-bg-green fw-bold">{TranslateString('moderator')}</td>
                        </tr>
                        <tr className="align-middle">
                            <td className="cu-bg-green" style={{width:"10%"}}><Input placeholder={TranslateString('search')} suffix={<BsArrowDownUp
                                onClick={() => {
                                    props.setSearchData({ ...props.searchData, sort_by: "log_for" })
                                    props.setSort(!props.sort)
                                }
                                }
                                role={"button"} />} onChange={onSearch} onPressEnter={onPressEnter} name="log_for" /></td>
                            <td className="cu-bg-green" style={{width:"7%"}}><Input placeholder={TranslateString('search')} onChange={onSearch} onPressEnter={onPressEnter} name="customer_id" /></td>
                            <td className="cu-bg-green" style={{width:"10%"}}><Input placeholder={TranslateString('search')} onChange={onSearch} onPressEnter={onPressEnter} suffix={<BsArrowDownUp
                                onClick={() => {
                                    props.setSearchData({ ...props.searchData, sort_by: "customer_name" })
                                    props.setSort(!props.sort)
                                }
                                }
                                role={"button"} />} name="customer_name" /></td>
                            <td className="cu-bg-green"><Input placeholder={TranslateString('search')} onChange={onSearch} onPressEnter={onPressEnter} name="loan_data_name" suffix={<BsArrowDownUp
                                onClick={() => {
                                    props.setSearchData({ ...props.searchData, sort_by: "loan_data_name" })
                                    props.setSort(!props.sort)
                                }
                                } role={"button"}/>} /></td>
                            <td className="cu-bg-green">
                                <Select
                                    placeholder={TranslateString('select')}
                                    showSearch
                                    className='w-100'
                                    allowClear
                                    onChange={(value: any) => {
                                        props.setSearchData({ ...props?.searchData, is_active: value  });
                                        setLogStatus({is_active:value})
                                    }}
                                    options={[...LogStatus.map(({value, label}) => {
                                        return {value : value, label: intl.formatMessage({id: convertToObjectKeyString(label.replace('-','_').toLocaleLowerCase())})}
                                   })]}/></td>
                            <td className="cu-bg-green"><Input placeholder={TranslateString('search')} onChange={onSearch} onPressEnter={onPressEnter} name="reason" suffix={<BsArrowDownUp
                                onClick={() => {
                                    props.setSearchData({ ...props.searchData, sort_by: "reason" })
                                    props.setSort(!props.sort)
                                }
                                } role={"button"}/>}/></td>
                            <td className="cu-bg-green"><Input placeholder={TranslateString('search')} onChange={onSearch} onPressEnter={onPressEnter} name="created_at" suffix={<BsArrowDownUp
                                onClick={() => {
                                    props.setSearchData({ ...props.searchData, sort_by: "created_at" })
                                    props.setSort(!props.sort)
                                }
                                } role={"button"}/>} /></td>
                            <td className="cu-bg-green"><Input placeholder={TranslateString('search')} onChange={onSearch} onPressEnter={onPressEnter} name="created_by" suffix={<BsArrowDownUp
                                onClick={() => {
                                    props.setSearchData({ ...props.searchData, sort_by: "created_by" })
                                    props.setSort(!props.sort)
                                }
                                } role={"button"}/>} /></td>
                        </tr>
                    </thead>
                    <tbody className="cu-text-small">
                        {props?.logData?.length > 0 ? props?.logData?.map((val: any) => {
                            return (
                                <tr key={Math.random()} >
                                    <td className="fw-bold">{TranslateString(val?.log_for)}</td>
                                    <td className="text-center fw-bold">{val?.customer_id}</td>
                                    <td>{val?.CUST_DATA?.customer_name}</td>
                                    <td>{val?.CUST_DATA?.LOAN_DATA?.loan_data_name}</td>
                                    <td>{val?.is_active == '1' ? 'Active' : 'In-active'}</td>
                                    <td className="">{val?.reason}</td>
                                    <td className="">{val?.created_at ? moment(val?.created_at).format("DD.MM.YYYY") : "-"}</td>
                                    <td className="">{val?.created_by}</td>
                                </tr>
                            )
                        }) : <tr><td colSpan={8}><Empty description={TranslateString('Empty')} /></td></tr>
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-between pb-2">
                    <div></div>
                    <div>
                        <Pagination
                            defaultCurrent={1}
                            current={props?.pageData?.page + 1}
                            pageSize={props?.paginationData?.pageSize}
                            total={props?.totalRecords || 0}
                            pageSizeOptions={[10, 20, 50, 100]}
                            locale={{ items_per_page: `${intl.formatMessage({ id: 'page' })}` }}
                            showTotal={(total: any, range: any) => `${range[0]}-${range[1]} ${intl.formatMessage({ id: 'of' })} ${total} ${intl.formatMessage({ id: 'items' })}`}
                            showSizeChanger={true}
                            onShowSizeChange={(page: any, pageSize: any) => {
                                props?.setPaginationData({
                                    ...props?.paginationData,
                                    pageSize: pageSize
                                });
                                props?.setPageData({
                                    size: pageSize,
                                    page: (props?.paginationData?.pageSize !== pageSize) ? 0 : page - 1,
                                });
                            }}
                            onChange={(page: any, pageSize: any) => {
                                props?.setPaginationData({
                                    pageSize: pageSize,
                                    page: page
                                });
                                props?.setPageData({
                                    size: pageSize,
                                    page: (props?.paginationData?.pageSize !== pageSize) ? 0 : page - 1,
                                });
                            }}
                        />
                    </div>
                </div>
        </>
    )
}

export default LogsList;